const CHECK_ITEMS = [
    { label: "Tires & Wheels", icon: "la-dot-circle" },
    { label: "Lights & Signals", icon: "la-lightbulb" },
    { label: "Windshield & Wipers", icon: "la-wind" },
    { label: "Mirrors", icon: "la-eye" },
    { label: "Brakes", icon: "la-compact-disc" },
    { label: "Horn", icon: "la-bullhorn" },
    { label: "Seat Belts", icon: "la-shield-alt" },
    { label: "Exterior Condition", icon: "la-car-side" },
];

const InspectionChecklist = () => {
    return (
        <section className="w-100 bg-light">
            <div className="container py-4">
                <h2 className="fw-bold text-dark text-center">
                   What We Check During Your Inspection
                </h2>
                <p className="mt-2 text-secondary text-center">Your inspector will guide you through the required vehicle inspection points during your live video call.</p>
            </div>

            {/* <div style={{ height: "8px" }} className="w-100 bg-dark" /> */}

            <div className="container py-4">
                <div className="row g-3">
                    {CHECK_ITEMS.map(({ label, icon }) => (
                        <div key={label} className="col-6 col-sm-3">
                            <div className="d-flex flex-column align-items-center justify-content-center gap-2 border rounded bg-white text-center px-3 py-4 h-100">
                                {icon && <i className={`las ${icon} text-secondary`} style={{ fontSize: "22px" }} />}
                                <span className="fw-semibold text-dark small">{label}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default InspectionChecklist;